import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { resetPassword } from "../../services/auth.services";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { globalLoader, handleServerValidations } from "../../../../utils/commonfunction";
import { useValidationSchemas } from "../../validator/validation";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logowide from '../../../../assets/center/images/logo-h.png'
import { DoctorResetPassword } from "../../../doctor/services/auth.services";

const CenterResetPassword = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { resetPswValidationSchema } = useValidationSchemas();
    const [newshow, setNewShow] = useState("false");
    const [conformshow, setConformShow] = useState("false");
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const userType = searchParams.get("select_role");
    const location = useLocation();

    useEffect(() => {
        // if (!state?.validate_string || state?.validate_string.length === 0) {
        //     navigate("/restaurant/login");
        // }
    }, [state, navigate]);

    const formik = useFormik({
        initialValues: {
            newPassword: "",
            confirmPassword: ""
        },
        validationSchema: resetPswValidationSchema,
        onSubmit: (values, { resetForm }) => {
            globalLoader(true);
            const formData = new FormData();
            formData.append("new_password", values.newPassword);
            formData.append("c_password", values.confirmPassword);
            formData.append("role", location?.state?.select_role);
            formData.append("validate_string", state.validate_string);
            if (location?.state?.select_role == 'center') {
                resetPassword(formData)
                    .then((response) => {
                        globalLoader(false);
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            resetForm();
                            navigate(`/${location?.state?.select_role}/login`);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        globalLoader(false);
                        console.log("error--->", error);
                    });
            } else {
                DoctorResetPassword(formData)
                    .then((response) => {
                        globalLoader(false);
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            resetForm();
                            navigate(`/${location?.state?.select_role}/login`);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        globalLoader(false);
                        console.log("error--->", error);
                    });
            }
        }
    });

    const handleshow = (event) => {
        if (event === "newpwd") {
            setNewShow(!newshow);
        }
        if (event === "confirmpwd") {
            setConformShow(!conformshow);
        }
    };

    return (
        <div className="auth-body d-flex align-items-center justify-content-center">
            <div className="auth-box">
                <div className="form-box-inner d-flex flex-column gap-5">
                    <div className="form-logo">
                        <img src={logowide} />
                    </div>
                    <div className="form-card">
                        <div className="form-text">
                            <h5 className="mt-2">{t("center.reset_password.heading")}</h5>
                            <p>{t("center.reset_password.description")}</p>
                        </div>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="form-group mb-3">
                                <label htmlFor="newPassword" className="form-label">{t('center.reset_password.label_new_password')} <span>*</span></label>
                                <div className="input-group">
                                    <input
                                        type={!newshow ? "text" : "password"}
                                        id="newPassword"
                                        name="newPassword"
                                        className="form-control border-end-0"
                                        placeholder={t("center.reset_password.placeholder_new_password")}
                                        value={formik.values.newPassword}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <span className="input-group-text cp restaurant-password-toggle" onClick={() => { handleshow("newpwd"); }}
                                    >
                                        {!newshow === true ? (
                                            <i className="ti ti-eye"></i>
                                        ) : (
                                            <i className="ti ti-eye-off"></i>
                                        )}

                                    </span>
                                </div>
                                <CustomError name="newPassword" form={formik} className="text-danger" />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="confirmPassword" className="form-label">{t("center.reset_password.label_confirm_password")}<span>*</span></label>
                                <div className="input-group">
                                    <input
                                        type={!conformshow ? "text" : "password"}
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        className="form-control border-end-0"
                                        placeholder={t("center.reset_password.placeholder_confirm_password")}
                                        value={formik.values.confirmPassword}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <span className="input-group-text cp restaurant-password-toggle" onClick={() => { handleshow("confirmpwd"); }}
                                    >
                                        {!conformshow === true ? (
                                            <i className="ti ti-eye"></i>
                                        ) : (
                                            <i className="ti ti-eye-off"></i>
                                        )}
                                    </span>
                                </div>
                                <CustomError name="confirmPassword" form={formik} className="text-danger" />
                            </div>
                            <button type="submit" className={"btn btn-primary w-100"}>
                                {t("center.reset_password.btn_submit")}
                            </button>
                        </form>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div className="back-text  d-flex gap-2 align-items-center">
                            <i className="ti ti-arrow-left"></i>
                            <Link class="link-text" to={`/${location?.state?.select_role}/login`} state={{ select_role: location?.state?.select_role }}>Back to Login</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default CenterResetPassword;
